import essenzaConfig from "./essenza300"
import essenzaLtConfig from "./essenza300lt"

export default [
  {
    name: 'essenza300',
    title: 'Essenza 300',
    image: 'essenza.png',
    category: 'ICU',
    model: 'models/essenza300/essenza_cistka_230718.gltf',
    configuration: essenzaConfig,
    default: false
  },
  {
    name: 'essenza300lt',
    title: 'Essenza 300LT',
    image: 'essenza.png',
    category: 'ICU',
    model: 'models/essenza300lt/essenza_cistka_LT_230718.gltf',
    configuration: essenzaLtConfig,
    default: true
  }
]